import { JiraServiceManagementIcon } from '@atlaskit/logo';
import { fg } from '@atlaskit/platform-feature-flags';
import type { ThirdPartyProductFilter } from '@atlassian/search-client';

import {
	DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
} from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo, RovoLogoFromLogo } from '../../icons';
import { JiraServiceManagementSearchResultIcon } from '../../icons/jira-service-management';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

export const jsmDCConfig: ThirdPartyConfig = {
	displayName: 'JSM Data Center',
	id: 'jsm-dc',
	resourceType: 'jsm-dc-connector',
	icon: RovoLogoFromLogo(JiraServiceManagementIcon, 'JSM Data Center'),
	searchResultIcon: get3PLogo(JiraServiceManagementSearchResultIcon, 'JSM Data Center', 'large'),
	integrationAri: 'ari:cloud:platform::integration/jira-dc',
	containerTypes: ['service_desk'],
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Project,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.ServiceDesk],
			},
		],
		[
			TypeFilterValueKey.Issue,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Issue],
			},
		],
		[
			TypeFilterValueKey.Comment,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated', 'project', 'assignee'],
	requiresOauth: true,
	isEnabled: () => fg('is_jsm_dc_enabled_in_ui'),
	fanOutConnectorSources: true,
	displayWorkspaceNameAsProductName: true,
	// For jira crawler, we want to filter by the domain of each datasource
	getSelectedDatasourceFilters: (datasource) => {
		const filters: Partial<ThirdPartyProductFilter> = {
			integrationId: datasource?.integrationAri,
			providerId: datasource?.providerId,
		};
		return filters;
	},
};
